import type { OtherFinancialTransaction } from '@coreledger/shared-types';
import { api } from './client';
import type { PaginationMeta } from './invoices';

export interface Paginated<T> { data: T[]; meta: PaginationMeta }

export interface OtherTransactionListFilter {
  type?: string;
  dateFrom?: string;
  dateTo?: string;
}

export const otherTransactionsApi = {
  list: (page = 1, limit = 50, filter: OtherTransactionListFilter = {}) => {
    const params = new URLSearchParams({ page: String(page), limit: String(limit) });
    if (filter.type) params.set('type', filter.type);
    if (filter.dateFrom) params.set('dateFrom', filter.dateFrom);
    if (filter.dateTo) params.set('dateTo', filter.dateTo);
    return api.get<Paginated<OtherFinancialTransaction>>(`/other-transactions?${params.toString()}`);
  },
  create: (data: Partial<OtherFinancialTransaction>) => api.post<OtherFinancialTransaction>('/other-transactions', data),
  update: (id: string, data: Partial<OtherFinancialTransaction>) => api.patch<OtherFinancialTransaction>(`/other-transactions/${id}`, data),
  delete: (id: string) => api.delete<void>(`/other-transactions/${id}`),
};
